/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */

/* NPM Imports Start */
import React from 'react';
import Button from 'devextreme-react/button';
/* NPM Imports End */

/* Project Imports Start */
import UserPanel from '../user-panel/user-panel';
import Breadcrumbs from './Breadcrumbs';
/* Project Imports End */

/* CCS & Image imports Start */
import './header.scss';
/* CCS & Image imports End */

const Header = () => (
  <header className={'headerComponent'}>
    <div className="leftContent">
      <div className="titleText">
        <h6>
          <Breadcrumbs />
        </h6>
        <p>
          <Breadcrumbs menuTitle={true} />
        </p>
      </div>
    </div>
    <div className="rightContent">
      <Button
        className={'user-button authorization'}
        stylingMode={'text'}
        elementAttr={{ 'data-cy': 'H-UserName-Button' }}>
        <UserPanel menuMode={'context'} />
      </Button>
    </div>
  </header>
);

Header.displayName = 'Header';

export default Header;

/* PropsTypes Validation Start*/

/* PropsTypes Validation End*/

/* DefaultProps */
Header.defaultProps = {
  menuTitle: false,
};
/* DefaultProps */
